import React from 'react';
interface ReassuranceProps {
  items: string[];
  tone?: 'light' | 'dark';
  className?: string;
}

/**
 * Repeated trust line used under every CTA:
 * un solo pago · acceso inmediato · de por vida · 100% digital · sin suscripciones.
 */
export function Reassurance({
  items,
  tone = 'light',
  className = ''
}: ReassuranceProps) {
  return <ul className={`flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs sm:text-sm ${tone === 'dark' ? 'text-violet-200' : 'text-gray-500'} ${className}`} data-id="element-112" data-mp="f8cvjniq488y">
      {items.map((item, i) => <li key={item} className="flex items-center gap-2" data-id="element-113" data-mp="12z8quume1lky" data-mpi={i}>
          {i > 0 && <span aria-hidden="true" className="opacity-50" data-id="element-114" data-mp="1311pbmmukzhv">
              ·
            </span>}
          <span data-id="element-115" data-mp="1bzwx335jihna">{item}</span>
        </li>)}
    </ul>;
}